import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  useLazyGetMembersBySearchForChannelQuery,
  useLazyGetTeamListQuery,
} from 'app/services/group.service'
import { useScheduleConferenceMutation } from 'app/services/conference.service'
import { FixMeLater } from 'types'
import { MODALS, TABS } from 'locales/locales'
import { IChannelMember } from 'types/user.types'

import AdvancedSettings from './AdvancedSettings'
import CreateMeetingForm from './CreateMeetingForm'
import CustomModal from 'components/modals/CustomModal'
import Participants from './Participants'
import { roundToNextTenMinutes } from 'utils/helpers/roundToNextTenMinuteHelper'
import { DeviceShareOptions } from 'utils/constants'
import { useCreateMeetingConversationMutation } from 'app/services/room.service'
import { useAppSelector } from 'app/hooks'

interface ICreateMeetingModalProps {
  onCancel: () => void
  onClose: () => void
}

const getIsEmail = (email: string) => {
  const emailRegex = /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/
  return emailRegex.test(email)
}
const CreateMeetingModal = ({ onCancel, onClose }: ICreateMeetingModalProps) => {
  const initalMeetingData = {
    meetingName: '',
    meetingDescription: '',
    meetingTime: roundToNextTenMinutes(new Date()),
    duration: '15',
    deviceRestriction: 0,
    hasWaitingRoom: false,
    hasEmailNotification: true,
    publicDraw: false,
    isPublic: true,
    guestMode: true,
    isPasswordProtected: false,
    password: '',
    isRepeatable: false,
    repeatDays: [],
    repeatEndTime: new Date(),
  }

  const { t } = useTranslation()
  const [members, setMembers] = useState<IChannelMember[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [formChecked, setFormChecked] = useState(false)
  const [meetingInput, setMeetingInput] = useState({ ...initalMeetingData })
  // const [selectedUsers, setSelectedUsers] = useState<FixMeLater>([])
  const [membersBySearch, setMembersBySearch] = useState<IChannelMember[]>([])
  const [selectedDeviceShareOption, setSelectedDeviceShareOption] = useState(DeviceShareOptions[0])
  const [selectedRepeatOptions, setselectedRepeatOptions] = useState<FixMeLater>([])

  const [selectedTeams, setSelectedTeams] = useState<FixMeLater>([])
  const [teamList, setTeamList ] = useState([])
  const [teamDropDownData, setTeamDropDownData] = useState<FixMeLater>([])
  const [teamSelectedOption, setTeamSelectedOption] = useState<FixMeLater>({})
  const myId = useAppSelector((state) => state.auth.id)
  // const [channelDropDownData, setChannelDropDownData] = useState<FixMeLater>([])
  // const [channelSelectedOption, setChannelSelectedOption] = useState({})


  const [getMembersBySearch] = useLazyGetMembersBySearchForChannelQuery()
  const [scheduleMeet] = useScheduleConferenceMutation()
  const [getTeamList] = useLazyGetTeamListQuery()

  useEffect(() => {
    // fetchMyChannels()
    fetchTeams()
    setIsLoading(false)
  }, [])

  // const fetchMyChannels = async () => {
  //   const data = (await getMyChannels({})) as FixMeLater

  //   const dropdownChannel = data.data.data.map((group:FixMeLater)=>{
  //     return{
  //       title:group.name,
  //       value:group._id
  //     }
  //   })

  //   setChannelDropDownData(dropdownChannel)
  // }

  const fetchTeams = async () => {
    try {
      const data = await getTeamList({})
      if (data?.data?.data) {
        const list = data.data.data.map((team: FixMeLater) => ({
          ...team,
          title: team.title || team.name,
          value: team.value || team._id,
          id: team.id || team._id,
        }))
        setTeamList(list)
        return data?.data?.data
      }
    } catch (error) {
      console.error(error)
    }
  }
  const [createMeetingConversation] = useCreateMeetingConversationMutation();

  const onOk = async () => {
    setFormChecked(true)
    const repeatDays = selectedRepeatOptions.map((option: FixMeLater) => option.value)
    const data = {
      meetingName: meetingInput.meetingName,
      meetingDescription: meetingInput.meetingDescription,
      meetingTime: meetingInput.meetingTime,
      duration: meetingInput.duration,
      deviceRestriction: selectedDeviceShareOption.value,
      hasWaitingRoom: meetingInput.hasWaitingRoom,
      hasEmailNotification: meetingInput.hasEmailNotification,
      publicDraw: meetingInput.publicDraw,
      isPublic: meetingInput.isPublic,
      guestMode: meetingInput.guestMode,
      isPasswordProtected: meetingInput.isPasswordProtected,
      password: meetingInput.password,
      isRepeatable: meetingInput.isRepeatable,
      repeatDays: repeatDays,
      repeatEndTime: meetingInput.repeatEndTime,
      forChannel: [],
      timeZoneOffset: -180,
      members,
      teamIds: [...selectedTeams.map((t: FixMeLater) => t._id)],
    }


    try {
      setIsLoading(true)
      const memberIds = Array.isArray(members) ? members.map((m: any) => m._id) : [];
      if (!memberIds.includes(myId)) {
        memberIds.push(myId);
      }
      const meetingRoomResponse = await createMeetingConversation({
        members: memberIds,
      });
      const { _id: chatRoomId } = meetingRoomResponse?.data?.data || {};

      const res: FixMeLater = await scheduleMeet({...data, roomId: chatRoomId})
      if (res?.data?.success) {
        onClose()
      }
    } finally {
      setIsLoading(false)
    }
  }



  useEffect(() => {
    const selectedValues = new Set(selectedTeams.map((team: FixMeLater) => team.value))
    const filtered = teamList.filter((team: FixMeLater) => !selectedValues.has(team.value))
    setTeamDropDownData(filtered)
  }, [selectedTeams, teamList])

  const onChangeInput = (value: string | boolean | Date | FixMeLater, key: string) => {
    if (key === 'channel_option') {
      // const filtered = channelDropDownData.filter((user: FixMeLater) => user.value !== value.value)
      // setChannelDropDownData(filtered)
      // setSelectedUsers([...selectedUsers, value])
      // if(filtered.length === 0){
      //   value = ''; //Prevent [object object]
      // }
      // setChannelSelectedOption(value)
      setSelectedTeams([...selectedTeams, value])
      setTeamSelectedOption(value)
    } else if (key === 'device_share_restriction') {
      setSelectedDeviceShareOption(value)
    } else if (key === 'repeat_days') {
      const index = selectedRepeatOptions.findIndex((option: FixMeLater) => {
        return option.value === value.value
      })
      if (index === -1) {
        setselectedRepeatOptions([...selectedRepeatOptions, value])
      }
    } else if (key === 'duration') {
      if ((parseInt(value) < 480 && parseInt(value) >= 0) || value === '') {
        setMeetingInput({ ...meetingInput, [key]: value })
      }
    } else {
      setMeetingInput({ ...meetingInput, [key]: value })
    }
  }

  const removeUser = (param: FixMeLater) => {
    // const filteredData = selectedUsers.filter((user: FixMeLater) => user.value !== param.value)
    const filteredData = selectedTeams.filter((team: FixMeLater) => team.value !== param.value)
    // setChannelSelectedOption({})
    // setSelectedUsers(filteredData)
    // setChannelDropDownData([...channelDropDownData, param])


    setTeamSelectedOption({})
    setSelectedTeams(filteredData)

  }
  const onSearch = async (text: string) => {
    try {
      const keyword = text.trim().toLowerCase()

      if (!keyword) {
        setMembersBySearch([])
        return
      }

      const result: FixMeLater = await getMembersBySearch({ searchName: text })

      const filteredUsers = (result?.data?.data || []).filter((fetchedUser: IChannelMember) => {
        const fetchedId = fetchedUser?._id
        const fetchedEmail = fetchedUser?.email?.trim().toLowerCase()

        const isAlreadyAdded = members.some((member) => {
          const memberId = member?._id
          const memberEmail = member?.email?.trim().toLowerCase()

          return (
            (memberId && fetchedId && memberId === fetchedId) ||
            (memberEmail && fetchedEmail && memberEmail === fetchedEmail)
          )
        })

        return !isAlreadyAdded
      })

      if (getIsEmail(text)) {
        const hasUser = members.some(
          (member) => member.email?.trim().toLowerCase() === keyword,
        )

        const hasInSearch = filteredUsers.some(
          (member: IChannelMember) => member.email?.trim().toLowerCase() === keyword,
        )

        if (!hasUser && !hasInSearch) {
          filteredUsers.push({ email: text.trim() })
        }
      }

      setMembersBySearch(filteredUsers)
    } catch (e) {
      console.log(e)
    }
  }

  const onSelectMember = (user: IChannelMember) => {
    setMembers((prev) => {
      const userId = user?._id
      const userEmail = user?.email?.trim().toLowerCase()

      const isExists = prev.some((member) => {
        const memberId = member?._id
        const memberEmail = member?.email?.trim().toLowerCase()

        return (
          (memberId && userId && memberId === userId) ||
          (memberEmail && userEmail && memberEmail === userEmail)
        )
      })

      if (isExists) return prev

      return [...prev, user]
    })

    setMembersBySearch((prev) =>
      prev.filter((member) => {
        const memberId = member?._id
        const memberEmail = member?.email?.trim().toLowerCase()
        const userId = user?._id
        const userEmail = user?.email?.trim().toLowerCase()

        return !(
          (memberId && userId && memberId === userId) ||
          (memberEmail && userEmail && memberEmail === userEmail)
        )
      }),
    )
  }

  const onRemoveUser = (user: IChannelMember) => {
    setMembers((prev) =>
      prev.filter((member) => {
        const memberId = member?._id
        const memberEmail = member?.email?.trim().toLowerCase()
        const userId = user?._id
        const userEmail = user?.email?.trim().toLowerCase()

        return !(
          (memberId && userId && memberId === userId) ||
          (memberEmail && userEmail && memberEmail === userEmail)
        )
      }),
    )
  }

  const onAssignModerator = (user: IChannelMember, isCancel?: boolean, isModerator?: boolean) => {
    if (isCancel) {
      return
    }
    const updatedMembers = members.map((member: IChannelMember) => {
      if (member._id === user._id) {
        return { ...member, isModerator: isModerator }
      }
      return member
    })
    setMembers([...updatedMembers])
  }

  const onRemoveRepeatDay = (value: FixMeLater) => {
    const removedData = selectedRepeatOptions.filter((option: FixMeLater) => {
      return option.value !== value.value
    })
    setselectedRepeatOptions(removedData)
  }

  const closeModal = () => {
    setFormChecked(false)
    onClose()
  }

  const tab = [
    { title: t(TABS.GENERAL), action: true },
    { title: t(TABS.PARTICIPANTS) },
    { title: t(TABS.ADVANCED) },
  ]

  return (
    <CustomModal
      closeModal={closeModal}
      title={t(MODALS.CREATE_MEETING_TITLE)}
      onCancel={onCancel}
      loading={isLoading}
      overflow={'visible'}
      tab={tab}
      onOk={onOk}
    >
      <CreateMeetingForm {...meetingInput} onChangeInput={onChangeInput} />
      <Participants
        key={members.length}
        {...meetingInput}
        data={members}
        channelDownData={teamDropDownData}
        channelSelectedOption={teamSelectedOption}
        selectedChannels={selectedTeams}
        formChecked={formChecked}
        searchedData={membersBySearch}
        onRemoveUser={onRemoveUser}
        onSelectMember={onSelectMember}
        removeUser={removeUser}
        onChangeInput={onChangeInput}
        onChangeSearchText={onSearch}
        onAssignModerator={onAssignModerator}
      />
      <AdvancedSettings
        {...meetingInput}
        selectedRepeatOptions={selectedRepeatOptions}
        selectedOption={selectedDeviceShareOption}
        onChangeInput={onChangeInput}
        onRemoveRepeatDay={onRemoveRepeatDay}
      />
    </CustomModal>
  )
}

export default CreateMeetingModal
